import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    textAlign: 'left',
  },
  list: {
    width: 280,
  },
  listItem: {
    float: 'left',
    listStyle: 'none',
    lineHeight: "200%",
    padding: '0.5rem',
    color: '#212121',
    fontSize: '80%'
  },
  sideListItem: {
    textAlign: 'center',
    color: '#212121',
    padding: 'auto',
    fontSize: '90%'
  }
}));

function ListItemLink(props) {
  return <ListItem divider button component="a" {...props} />;
}

export default function ResponsiveDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [side]: open });
  };

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <ListItemLink href="/">
          <ListItemText disableTypography className={classes.sideListItem} primary="ホーム" />
        </ListItemLink>
        <ListItemLink href="/guide-overview">
          <ListItemText disableTypography className={classes.sideListItem} primary="会社概要" />
        </ListItemLink>
        <ListItemLink href="https://recruit.daily-tohoku.company/">
          <ListItemText disableTypography className={classes.sideListItem} primary="採用情報" />
        </ListItemLink>
        <ListItemLink href="/guide-shop">
          <ListItemText disableTypography className={classes.sideListItem} primary="購読のご案内" />
        </ListItemLink>
        <ListItemLink href="/guide-advertisement">
          <ListItemText disableTypography className={classes.sideListItem} primary="広告・折込のご案内" />
        </ListItemLink>
        <ListItemLink href="https://event-guide.daily-tohoku.news/#sec-event">
          <ListItemText disableTypography className={classes.sideListItem} primary="主催事業" />
        </ListItemLink>
        <ListItemLink href="https://event-guide.daily-tohoku.news/#sec-ticket">
          <ListItemText disableTypography className={classes.sideListItem} primary="チケット情報" />
        </ListItemLink>
        <ListItemLink href="/guide-facility">
          <ListItemText disableTypography className={classes.sideListItem} primary="ホール貸出" />
        </ListItemLink>
        <ListItemLink href="/guide-service">
          <ListItemText disableTypography className={classes.sideListItem} primary="サービス" />
        </ListItemLink>
        <ListItemLink href="https://form.daily-tohoku.org/shoseki-top">
          <ListItemText disableTypography className={classes.sideListItem} primary="書　籍" />
        </ListItemLink>
        <ListItemLink href="/guide-wanted">
          <ListItemText disableTypography className={classes.sideListItem} primary="投稿・応募" />
        </ListItemLink>
        <ListItemLink href="/guide-delion">
          <ListItemText disableTypography className={classes.sideListItem} primary="デリオンくらぶ" />
        </ListItemLink>
        <ListItemLink href="/forum">
          <ListItemText disableTypography className={classes.sideListItem} primary="政経懇話会" />
        </ListItemLink>
        <ListItemLink href="/guide-contactus">
          <ListItemText disableTypography className={classes.sideListItem} primary="お問い合わせ" />
        </ListItemLink>
        <ListItemLink href="https://www.daily-tohoku.news/">
          <ListItemText disableTypography className={classes.sideListItem} primary="デーリー東北デジタルへ" />
        </ListItemLink>
        <ListItemLink href="/">
          <Box p={3}>
            <div className="my-3">
              <img src="/images/logo.png" className="img-fluid" /><br/>
            </div>
            <div className="text-center fs90 line150">
              〒031-8601<br/>
              青森県八戸市城下１丁目３-12<br/>
              <PhoneEnabledIcon />0178-44-5111<br/>
            </div>
          </Box>
        </ListItemLink>
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar className="bg-info">
          <IconButton
           edge="start"
           className={classes.menuButton}
           color="inherit"
           aria-label="menu"
           onClick={toggleDrawer('left', true)}
          >
            <MenuIcon className="text-dark" />
          </IconButton>
          <SwipeableDrawer open={state.left} onClose={toggleDrawer('left', false)}>
            {sideList('left')}
          </SwipeableDrawer>
          <Typography variant="h6" className={classes.title}>
          </Typography>
          <div className="d-block">
            <a href="/"><img src="/images/logo-top.png" className="img-fluid" width="180" /></a>
          </div>

          {/*
          <div className="d-none d-lg-block">
            <Button className={classes.listItem} href="/">ホーム</Button>
            <Button className={classes.listItem} href="/subscription">購　読</Button>
            <Button className={classes.listItem} href="/personal">写真販売・チケット</Button>
            <Button className={classes.listItem} href="/corporation">広告・チラシ・出版</Button>
            <Button className={classes.listItem} href="/hall">ホール貸館</Button>
            <Button className={classes.listItem} href="/event">事　業</Button>
            <Button className={classes.listItem} href="/identity">会社案内</Button>
            <Button className={classes.listItem} href="/contactus">問い合わせ</Button>
          </div>
            */}
        </Toolbar>
      </AppBar>
    </div>
  );
}
